import { useGlobalAuth } from '@headbox-ui/auth-hook'
import React, { useEffect, FC } from 'react'
import { useGlobalState } from '../../Store'
import { useActorRoleContext } from '../../BusinessLogic'

const Authenticator: FC = ({ children }): JSX.Element => {
  const [, setSession] = useGlobalState('session')
  const { authenticated, loading, user, jwt } = useGlobalAuth()
  const role = useActorRoleContext(user)
  const authComplete: boolean = (!authenticated && !loading && jwt === undefined) || (authenticated && user !== undefined)

  useEffect(() => {
    setSession({ role, user })
  }, [role, user])

  if (authComplete) {
    return (
      <>{children}</>
    )
  }

  return null
}

export default Authenticator
